module.exports = __webpack_public_path__ + "static/media/velikonoce.4a7f0c63.jpg";